(function ($, Cobalt, undefined) {
    var _manager = null;
    var _listing = null;
    var _ordinal = 0;
    var _initialized = false;

    function updateDisplayOrder() {
        // Update the display order
        var counter = 0;
        _listing.find("li.j-navigation-item").each(function () {
            var navItem = $(this).data("navigation-item");
            navItem.setDisplayOrder(++counter);
        });
    }

    function setOrdinal(val) {
        _ordinal = val;
        _manager.find("input.j-max-ordinal").val(val)
    }

    function addNavItem(element, parent) {

        setOrdinal(++_ordinal);

        var navItem = null;
        if (parent == null) {
            navItem = new Cobalt.NavigationItem({ "parent": parent, "element": element });
        }
        else {
            navItem = parent.addItem(element, true);
        }

        // Get any children, and recusively call this method
        element.find("ol > li").each(function () {
            addNavItem($(this), navItem);
        });

    };


    function addNewNavItem(url, parentElement) {

        _manager.mask();

        $.ajax(
        {
            type: "POST",
            dataType: "json",
            url: url,
            success: function (data) {
                _manager.unmask();

                if (!data.Success) {
                    return;
                }
                var element = $(data.html);
                if (parentElement != null && parentElement.length > 0) {
                    var ol = parentElement.find(">ol");
                    if (ol.length == 0) {
                        ol = $("<ol>");
                        parentElement.append(ol);
                    }
                    ol.append(element);
                }
                else 
                {
                    _listing.append(element);
                }
                Cobalt.triggerHtmlInsert(element);
                addNavItem(element, null);
                updateDisplayOrder();
            }
        });
    }

    function bindUI() {

        // Bind Role Visibility
        $("#j-navigation-manager").on("change", "input.j-nav-visibility", function () {
            var $parentContainer = $(this).parents("li.j-roles-management");
            var $rolesContainer = $parentContainer.find("div.j-required-roles");

            if ($(this).is(":checked")) {
                $rolesContainer.show();
            }
            else {
                $rolesContainer.hide();
            }
        });
        // Set the initial state correctly
        $("li.j-roles-management").each(function () {
            if ($(this).find("input.j-nav-visibility").is("checked")) {                
                $(this).find("div.j-required-roles").show();
            }

        });

        $("#j-navigation-manager").delegate("a.icon.delete", "click", function () {
            var navItem = $(this).parents(".j-navigation-item").data("navigation-item");
            navItem.remove();
        });

        $("#j-navigation-manager").delegate("a.j-show-advanced", "click", function () {
            $(this).parents("table").toggleClass("show-advanced");
            if ($(this).parents("table").hasClass("show-advanced")) {
                $(this).text("Hide Advanced");
            }
            else {
                $(this).text("Show Advanced");
            }

        });

        $("#j-navigation-manager").delegate("select.j-add-special-nav", "change", function () {
            var selected = $(this).find("option:selected");
            if (!selected) {
                return;
            }
            var navType = selected.attr("data-nav-type");
            if (!navType) {
                return;
            }
            var entityTypeID = selected.attr("data-entity-type-id");
            var entityID = selected.attr("data-entity-id");
            var url = "/cp/navigation/add-item?type=" + navType + "&ordinal=" + _ordinal + "&parentOrdinal=0&entityTypeID=" + entityTypeID + "&entityID=" + entityID;
            addNewNavItem(url, null);
        });


        $("#j-navigation-manager").delegate("a.j-add-nav", "click", function () {

            var navElem = $(this).parents(".j-navigation-item").first();
            var navItem = navElem.data("navigation-item");
            var parentOrdinal = (navItem != null) ? navItem.ordinal : 0;
            $.log(parentOrdinal);
            var url = "/cp/navigation/add-item?type=1&ordinal=" + _ordinal + "&parentOrdinal=" + parentOrdinal;
            addNewNavItem(url, navElem);
        });
    };


    function attachToManager($parent) {

        _manager = $("div#j-navigation-manager");

        if (_manager.data("navigation-manager-attached")) {
            return;
        }

        _ordinal = 0;
        _manager.data("navigation-manager-attached", true)
        _listing = $("div#j-navigation-manager ol.j-navigation-list").first();

        // Setup items
        _listing.find("> li").each(function () {
            addNavItem($(this), null);
        });

        // Setup form ajax
        _manager.find(">form").ajaxForm({
            type: 'post',
            cache: false,
            beforeSubmit: function () {
                _manager.mask();
            },
            success: function (data) {
                setTimeout(function () { _manager.unmask(); }, 500);
                $.log(data);
            }
        });

        // Make the list sortable
        _listing.nestedSortable({
            disableNesting: 'no-nest',
            forcePlaceholderSize: true,
            handle: 'div.drag-handle > a.icon-drag-handle',
            items: 'li.j-navigation-item',
            placeholder: 'placeholder',
            tabSize: 25,
            opacity: 0.65,
            tolerance: 'pointer',
            toleranceElement: '> div',
            stop: function (e, ui) {
                var dragged = $(ui.item);
                if (dragged.length == 0) {
                    return;
                }

                $.log("Stop!");
                $.log(dragged);

                var navItem = dragged.data("navigation-item");
                if (navItem == null) {
                    return;
                }
                var newParentElement = dragged.parents("li.j-navigation-item");
                var newParent = null;
                if (newParentElement.length >= 1) {
                    newParent = newParentElement.data("navigation-item");
                }

                navItem.moveTo(newParent);

                updateDisplayOrder();

                $.log(newParent);
            }
        });


        updateDisplayOrder();

        bindUI();
    }

    Cobalt.NavigationManager = {

        initialize: function () {

            if (_initialized) {
                return;
            }
            _initialized = true;
            Cobalt.runOnHtmlInsert(function ($parent) { attachToManager($parent); });
        }

    }
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.NavigationManager.js